// extracted by mini-css-extract-plugin
module.exports = {"name":"MarketTitle__name___3s5m_","ellipsis":"MarketTitle__ellipsis___fM2H7"};